<template>
  <header class="app-header">
    <div class="container header-container">
      <div class="brand" @click="$emit('reset-view')">
        <span class="brand-icon">🍳</span>
        <div class="brand-text">
          <h1>Receptbanken</h1>
          <p class="tagline">Från frasiga pannkakor till kryddiga indiska rätter</p>
        </div>
      </div>

      <div class="search-wrapper">
        <span class="search-icon">🔍</span>
        <input
          type="text"
          :value="modelValue"
          @input="$emit('update:modelValue', $event.target.value)"
          placeholder="Sök recept eller ingrediens..."
          class="search-input"
          autocomplete="off"
        />
        <button
          v-if="modelValue"
          class="clear-search-btn"
          @click="$emit('update:modelValue', '')"
          title="Rensa sökning"
          type="button"
        >
          ✕
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue', 'reset-view']
}
</script>

<style scoped>
.app-header {
  background-color: var(--color-card-bg);
  border-bottom: 1px solid var(--color-border);
  padding: 16px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: var(--shadow-sm);
  transition: padding 0.2s ease;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  user-select: none;
}

.brand-icon {
  font-size: 2.2rem;
  line-height: 1;
}

.brand-text h1 {
  font-size: 1.45rem;
  font-weight: 700;
  color: var(--color-text-main);
  line-height: 1.2;
}

.tagline {
  font-size: 0.85rem;
  color: var(--color-text-muted);
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 260px;
  max-width: 380px;
  flex: 1;
}

.search-icon {
  position: absolute;
  left: 14px;
  font-size: 0.95rem;
  color: var(--color-text-muted);
  pointer-events: none;
}

.search-input {
  width: 100%;
  height: 44px;
  padding: 10px 40px 10px 38px;
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-lg);
  font-size: 16px; /* 16px förhindrar automatisk zoom på iOS Safari */
  background-color: var(--color-bg-body);
  color: var(--color-text-main);
  outline: none;
  transition: all 0.2s ease;
}

.search-input:focus {
  border-color: var(--color-primary);
  background-color: #fff;
  box-shadow: 0 0 0 3px rgba(230, 81, 0, 0.15);
}

.clear-search-btn {
  position: absolute;
  right: 6px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-muted);
  font-size: 0.9rem;
  border-radius: 50%;
}

.clear-search-btn:hover,
.clear-search-btn:active {
  color: var(--color-text-main);
  background-color: rgba(0, 0, 0, 0.05);
}

@media (max-width: 640px) {
  .app-header {
    padding: 12px 0;
  }
  .header-container {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
  .brand-icon {
    font-size: 1.8rem;
  }
  .brand-text h1 {
    font-size: 1.25rem;
  }
  .tagline {
    font-size: 0.78rem;
  }
  .search-wrapper {
    max-width: 100%;
    min-width: 100%;
  }
}
</style>
